import React from 'react';
import './loading.scss';

export const Loading = (props) => (<div className={`loader ${props.isInteral ? 'small' : 'big'} ${props.isCenter ? 'center' : ''}`}/>)